import { renderSlot as _renderSlot, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_tabbed_section = _resolveComponent("ontos-tabbed-section")!

  return (_openBlock(), _createBlock(_component_ontos_tabbed_section, {
    ref: "tabs",
    tabs: _ctx.views,
    opens: "property"
  }, {
    default: _withCtx(({tab}) => [
      _withDirectives(_createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "property")
      ], 512), [
        [_vShow, tab === 'property']
      ]),
      (_ctx.validation)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "validation")
          ], 512)), [
            [_vShow, tab === 'validation']
          ])
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "access")
      ], 512), [
        [_vShow, tab === 'access']
      ])
    ]),
    _: 3
  }, 8, ["tabs"]))
}